module.exports = __webpack_public_path__ + "static/media/banner.d027e33b.png";